module.exports = __webpack_public_path__ + "img/menuDetail3.eb46da3f.png";